export default __webpack_public_path__ + "static/media/banner.f0339b6b.jpg";